import { render } from "./TheDocument.vue?vue&type=template&id=6801fa95"
import script from "./TheDocument.vue?vue&type=script&lang=js"
export * from "./TheDocument.vue?vue&type=script&lang=js"
script.render = render

export default script